import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';

import { GroupListProp } from './pickAGroupStep.types';
import { useMst } from '../../../models/rootModel';

import { BaseStep } from '../../common/BaseStep';
import { CarouselComponent, CarouselType } from '../../common/CarouselComponent';
import { GroupCard } from '../../common/GroupCard';

const DisplayColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 32px 48px 32px;
  @media (max-width: 600px) {
    padding: 40px 32px;
  }
`;

export const GroupList = observer((props: GroupListProp) => {
  const { openGroupPopUp, stepName, groupButton, isButtonDisabled } = props;
  const { Group } = useMst();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BaseStep {...props}>
      {isMobile ? (
        <CarouselComponent
          stepName={stepName}
          isButtonDisabled={isButtonDisabled}
          type={CarouselType.Group}
          buttonText={groupButton}
          onClick={(groupId: string) => openGroupPopUp(groupId)}
        />
      ) : (
        <DisplayColumn>
          {Group.groups.map((group, index) => (
            <GroupCard
              id={`selectGroup_${index + 1}`}
              group={group}
              key={group.id}
              stepName={stepName}
              isCarousel={false}
              buttonText={groupButton}
              onClick={() => openGroupPopUp(group.id)}
              isButtonDisabled={isButtonDisabled}
            />
          ))}
        </DisplayColumn>
      )}
    </BaseStep>
  );
});
